import React, {useContext} from 'react'

import PropTypes from "prop-types";
import {Navigate} from 'react-router'

import ConfigContext from '../ConfigContext'

function RequireAuth({ children, requireSuperuser = false, requiredPermissions = [], allowedPermissions = []}) {
    const context = useContext(ConfigContext)

    if (!context.auth.isAuthenticated()) {
        return <Navigate to={'/login/redirect'} replace/>
    }

    const hasAllRequiredPermissions = requiredPermissions && requiredPermissions.length > 0
        ? context.auth.hasPermissions(requiredPermissions)
        : true

    let hasAllowedPermission = true;
    if (allowedPermissions && allowedPermissions.length > 0) {
        hasAllowedPermission = false;

        allowedPermissions.forEach((p) => {
            if (context.auth.hasPermission(p)) {
                hasAllowedPermission = true;
            }
        });
    }

    // Not authorized for this resource, redirect to 403
    if ((requireSuperuser && !context.auth.isSuperUser()) || !hasAllRequiredPermissions || !hasAllowedPermission) {
        return <Navigate to={'/403/redirect'} replace/>
    }

    return children
}

RequireAuth.propTypes = {
    allowedPermissions: PropTypes.array,
    children: PropTypes.any.isRequired,
    requireSuperuser: PropTypes.bool,
    requiredPermissions: PropTypes.array,
}

export default RequireAuth